/**
 * Developer Access — LSP developer API (Task 10), mounted at
 * /api/v1/partner/dev-access (backend developer.routes.ts). The fence lets an
 * lsp_developer login call only this prefix (+ notifications, self-service auth).
 * `open` is the ONLY call that returns values; they go straight to router state.
 */
import { api } from '../../utils/api';
import type { DevItemKey, DevSystem, RequestDTO, SendCodeResult, ShareDTO } from '../dev-access/api';
export type { DevItemKey, DevSystem, RequestDTO, RequestStatus, SendCodeResult, ShareDTO, ShareStatus } from '../dev-access/api';

export interface CatalogueEntry { key: string; label: string; scope: string; path: string }
export interface CreateRequestBody { system: DevSystem; apis: string[]; items: DevItemKey[]; ipAddresses: string[]; reason: string }
export interface OpenShareResult { items: Array<{ name: string; value: string }>; closesAt: string }
/** A15 — the developer's gateway client. Never the secret. */
/** The developer's partner + login for the shell chip (GET /partner/dev-access/me). */
export interface DeveloperMe { partner: { id: string; name: string }; developer: { email: string; name: string } }
export interface GatewayClientDTO { id: string; keyId: string; allowedIp: string | null; ipUpdatedAt: string | null; apis: string[]; transfersEnabled: boolean; createdAt: string }

async function unwrap<T>(promise: Promise<{ data: { data: T } }>): Promise<T> {
  const res = await promise;
  return res.data.data;
}

const base = '/partner/dev-access';

export const developerApi = {
  me: () => unwrap<DeveloperMe>(api.get(`${base}/me`)),
  catalogue: () => unwrap<CatalogueEntry[]>(api.get(`${base}/catalogue`)),
  shares: () => unwrap<ShareDTO[]>(api.get(`${base}/shares`)),
  requests: () => unwrap<RequestDTO[]>(api.get(`${base}/requests`)),
  createRequest: (body: CreateRequestBody) => unwrap<RequestDTO>(api.post(`${base}/requests`, body)),
  sendCode: (shareId: string) => unwrap<SendCodeResult>(api.post(`${base}/shares/${encodeURIComponent(shareId)}/code`)),
  open: (shareId: string, code: string) => unwrap<OpenShareResult>(api.post(`${base}/shares/${encodeURIComponent(shareId)}/open`, { code })),
  gateway: () => unwrap<GatewayClientDTO[]>(api.get(`${base}/gateway`)),
  sendIpCode: (clientId: string) => unwrap<SendCodeResult>(api.post(`${base}/gateway/${encodeURIComponent(clientId)}/ip/code`)),
  setIp: (clientId: string, ip: string, code: string) => unwrap<GatewayClientDTO>(api.put(`${base}/gateway/${encodeURIComponent(clientId)}/ip`, { ip, code })),
};
